module.exports = __webpack_public_path__ + "static/img/hqzc.3b945463.png";